import { inject } from '@angular/core';
import {
  Attachment,
  AttachmentsService,
} from '@kinet-open-network/client/attachments/data-access';
import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  withMethods,
  withState,
} from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';

interface MapImageState {
  mapImage: Attachment | null;
  mapImageLoading: boolean;
  mapImageError: any;
}

export function withMapImage() {
  return signalStoreFeature(
    withState<MapImageState>({
      mapImage: null,
      mapImageLoading: false,
      mapImageError: null,
    }),
    withMethods((store, attachmentsService = inject(AttachmentsService)) => ({
      loadMapImage: async (id: string) => {
        patchState(store, { mapImageLoading: true });

        const mapImage = await firstValueFrom(
          attachmentsService.getById(id).pipe(
            tapResponse({
              next: (attachment) => {
                patchState(store, {
                  mapImage: attachment,
                  mapImageLoading: false,
                });
              },
              error: (error) =>
                patchState(store, {
                  mapImageLoading: false,
                  mapImageError: error,
                }),
            }),
          ),
        );

        return mapImage;
      },
    })),
  );
}
